import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const TeachDayHeaderEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.teachDayHeader),
        title: Type.Optional(Type.String()),
        dayNumber: Type.Optional(Type.Integer()),
        dayLabel: Type.Optional(Type.String()),
        dayDescription: Type.Optional(Type.String()),
        investigationDay: Type.Optional(Type.String()),
        investigationDayNumber: Type.Optional(Type.Integer()),
        isStudy: Type.Boolean(),
        isSmartTeach: Type.Boolean()
    })
]));
